// Author Liang Gang Qiang
// Date 2021-10-29 09:49:47

class ImfMstLocationTagLoct {
constructor({
        id = null,
        loctIdLoc = '',
        loctTagCode = '',
        loctAdditionalCodeA = '',
        loctAdditionalCodeB = '',
        loctAdditionalCodeC = '',
        remark = ''}
= {}) {
    this.id = id;
    this.loctIdLoc = loctIdLoc;
    this.loctTagCode = loctTagCode;
    this.loctAdditionalCodeA = loctAdditionalCodeA;
    this.loctAdditionalCodeB = loctAdditionalCodeB;
    this.loctAdditionalCodeC = loctAdditionalCodeC;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstLocationTagLoct();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'loctIdLoc',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.loctIdLoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationCode',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.locationCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationNodeCode',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.locationNodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'machineType',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.machineType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '集团' },
                            { value: '2', text: '公司' },
                            { value: '3', text: '车间/部门' },
                            { value: '4', text: '工段' },
                            { value: '5', text: '料仓' }
            ]
        }
        },
        {
        key: 'loctTagCode',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.loctTagCode',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '球团' },
                            { value: '2', text: '冶炼' }
            ]
        }
        },
        {
        key: 'loctAdditionalCodeA',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.loctAdditionalCodeA',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'loctAdditionalCodeB',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.loctAdditionalCodeB',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'loctAdditionalCodeC',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.loctAdditionalCodeC',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstLocationTagLoct.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    loctIdLocFilter : '',
    mstLocationNodeCodeStartsWithFilter : '',
    loctTagCodeFilter : '',
    loctAdditionalCodeAFilter : '',
    loctAdditionalCodeBFilter : '',
    loctAdditionalCodeCFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'loctIdLocFilter',
        label: 'label.em.admin.imfMstLocationTagLoct.filter.loctIdLoc',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'loctTagCodeFilter',
        label: 'label.em.admin.imfMstLocationTagLoct.filter.loctTagCode',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '球团' },
                { value: '2', text: '冶炼' }
            ]
        }
        },
        {
        key: 'loctAdditionalCodeAFilter',
        label: 'label.em.admin.imfMstLocationTagLoct.filter.loctAdditionalCodeA',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loctAdditionalCodeBFilter',
        label: 'label.em.admin.imfMstLocationTagLoct.filter.loctAdditionalCodeB',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loctAdditionalCodeCFilter',
        label: 'label.em.admin.imfMstLocationTagLoct.filter.loctAdditionalCodeC',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'loctIdLoc',
        label: 'label.em.admin.imfMstLocationTagLoct.entity.loctIdLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'loctTagCode',
        label: 'label.em.admin.imfMstLocationTagLoct.entity.loctTagCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '球团' },
                { value: '2', text: '冶炼' }
            ]
        }
        },
        {
        key: 'loctAdditionalCodeA',
        label: 'label.em.admin.imfMstLocationTagLoct.entity.loctAdditionalCodeA',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loctAdditionalCodeB',
        label: 'label.em.admin.imfMstLocationTagLoct.entity.loctAdditionalCodeB',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loctAdditionalCodeC',
        label: 'label.em.admin.imfMstLocationTagLoct.entity.loctAdditionalCodeC',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstLocationTagLoct.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstLocationTagLoct, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
